
import { Extensions } from "../Framework/Extensions";
import "inputmask";

export module Common {

	export class Options {
		clearIncomplete: Boolean;
		regex: any;
		mask: any;
		onincomplete: any;
	}

	export async function initAllAsync(container: JQuery): Promise<void> {

		var count = container.find("[data-mask],[data-mask-regex-pattern], [data-inputmask]").length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find("[data-mask],[data-mask-regex-pattern], [data-inputmask]"), async (i, e) => {
				var textbox = new MaskedTextbox($(e));

				await textbox.initAsync();
				count -= 1;
				if (count == 0)
					resolve();
			});

			//container.find("[data-mask],[data-mask-regex-pattern], [data-inputmask]").each(async function () {
			//	var textbox = new MaskedTextbox($(this));

			//	await textbox.initAsync();
			//	count -= 1;
			//	if (count == 0)
			//		resolve();
			//});

		});

	}


	export class MaskedTextbox {
		private element: JQuery;

		constructor(elem: JQuery) {
			this.element = elem;
		}

		public initAsync(): Promise<void> {
			var self = this;

			(<any>window).Inputmask.extendAliases({
				"mm:ss": {
					mask: "999:s",
					placeholder: "mmm:ss",
					alias: "minutesecond",
					autoUnmask: !1
				}
			});

			return new Promise<void>((notify, reject) => {

				self.setup(self.element);

				notify();
			});

		}

		private changeInputTypeToText($elem: JQuery) {

			var type = $elem.attr("type");
			if ((type == "text") || (type == "tel"))
				return;

			$elem.attr("type", this.getNewType($elem));

			if ((<any>$elem[0]).createTextRange) {
				var part = (<any>$elem[0]).createTextRange();
				part.move("character", 0);
				part.select();
			}
			else if ((<any>$elem[0]).setSelectionRange)
				(<any>$elem[0]).setSelectionRange(0, 0);

		}

		private getNewType($elem: JQuery): string {

			var newType = "text";
			var type = $elem.attr("type");

			if ((type == "tel") || (type == "number"))
				newType = "tel";

			return newType;
		}


		protected setup($elem: JQuery): void {
			if (!($ && $.fn && $.isFunction($.fn.inputmask) ))
				return;

			var type = $elem.attr("type");
			this.changeInputTypeToText($elem);

			if ((type != "text") && (type != "tel")) {

				$elem.focusin((e) => {
					this.changeInputTypeToText($elem);
				});

				$elem.focus((e) => {
					this.changeInputTypeToText($elem);
				});

				$elem.on("keydown", function (e) {
					if (e.keyCode == 9) {
						$elem.attr("type", type)
					}
				});

				$elem.on("focus", () => {
					this.changeInputTypeToText($elem);
				});

				$elem.on("blur", () => {
					$elem.attr("type", type);
				});
			}


			var tabIndex = $elem.attr("tabindex");
			if (!tabIndex)
				$elem.attr("tabindex", "0")

			var options = new Options();
			options.clearIncomplete = true;
			options.onincomplete = function () { console.error("incomplete") };

			$elem.attr("data-inputmask-clearIncomplete", "true");

			var dataRegex = $elem.data("mask-regex-pattern");

			var inputMask = $elem.data("inputmask");
			if (dataRegex) {

				options.regex = dataRegex;
				$elem.inputmask(
					"Regex",
					{
						regex: dataRegex,
						placeholder: "mmm:ss"
					}
				);
			}
			else if (inputMask) {
				var mask = $elem.data("inputmask") + "";
				if (mask != "")
					$elem.inputmask(options);

			}
			else {
				var mask = JSON.parse($elem.data("mask")) + "";
				if (mask != "")
					$.extend(options, mask);
				//options.mask = mask;
				$elem.inputmask(options);
			}

			var placeholder = $elem.data("placeholder") || "";
			if (placeholder != "")
				$elem.attr("placeholder", placeholder);

			$elem.css("text-align", "left");



			$elem.attr("type", type);


		}

	}
}
